import { Slider } from "@mui/material";
import React, { useEffect } from "react";
import "./rangeSelector.css";
import CurrencyConvertor from "../../currency-convertor";

const RangeSelector = ({ heading, initialvalue, step = 1, min = 0, max = 100, handleCommitedChange }) => {
  const [value, setValue] = React.useState(initialvalue || []);

  function handleChange(event, newValue) {
    if (newValue[0] === newValue[1]) {
      return;
    }
    setValue(newValue);
  }

  useEffect(() => {
    setValue(initialvalue);
  }, [initialvalue]);

  return (
    <section className="rangeSelector">
      <h5>{heading}</h5>
      <div className="StartEndRange">
        <CurrencyConvertor price={Number(value[0]) || 0} />
        <span>-</span>
        <CurrencyConvertor price={Number(value[1]) || 0} />
      </div>
      <Slider
        sx={{
          width: 225,
          color: "#787878",
          height: 3,
          "& .MuiSlider-thumb": {
            width: "16px",
            height: "16px",
            backgroundColor: "#ffffff",
            border: "2px solid #787878",
          },
        }}
        min={min}
        max={max}
        step={step}
        getAriaLabel={() => "Minimum distance shift"}
        value={value}
        onChange={handleChange}
        onChangeCommitted={(event, newValue) => handleCommitedChange(newValue, heading)}
      />

      {/* <div className="StartEndRange">
        <span>{start}</span>
        <span>{end}</span>
      </div> */}
    </section>
  );
};

export default RangeSelector;
